import { Button, Form, Input, Typography } from "antd";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import React, { useState } from "react";

const { Text, Link } = Typography;
const phoneUtil = PhoneNumberUtil.getInstance();
function PhoneValidationStep({ data }) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [Verified, setVerified] = useState(false);
  const [validation, setValidation] = useState("");


  const validatePhoneNumber = async () => {
    setLoading(true);
    const unformattedPhoneNumber = data.phoneNumber;
    const e164ContactPhoneNumberObject = phoneUtil.parseAndKeepRawInput(unformattedPhoneNumber, 'US');
    const e164ContactPhoneNumber = phoneUtil.format(e164ContactPhoneNumberObject, PhoneNumberFormat.E164);
    const verificationData = {
      contactId: data?.contactId || 0,
      contactFirstName: data.firstName,
      contactLastName: data.lastName,
      contactEmail: data.email,
      contactCompanyName: data.companyName,
      contactPhoneNumber: e164ContactPhoneNumber,
      phoneNumberVerificationCode: validation
    };
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(verificationData)
    };

    try {
      const res = await fetch(process.env.REACT_APP_PHONE_NUMBER_VERIFICATION_ENDPOINT ?? "", requestOptions);
      if (res.status === 200) {
        setVerified(true);
        setErrorMessage(null);
        const resBody = await res.json(); // or use res.text() if it's not JSON
        data.setValues(resBody);
      } else {
        const errorData = await res.text();
        setErrorMessage(errorData.message || "Failed to verify phone number."); // Assuming your server sends an error message in the response. Otherwise, default to a generic message.
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to verify phone number.");
    } finally {
      setLoading(false);
    }

  };

  return (
    <div>
      {" "}
      <Form layout="vertical">
        <Form.Item label="Please enter the code sent to your device:">
          <Input.Group compact>
            <Input style={{ width: "calc(100% - 70px)", height: 40 }} onChange={(e) => {
              setValidation(e.target.value);
            }} />
            <Button
              style={{ height: 40, width: 70 }}
              disabled={loading}
              loading={loading}
              type="primary"
              onClick={validatePhoneNumber}
            >
              {!loading && "Verify"}
            </Button>
          </Input.Group>
          {errorMessage && <Text type="danger" style={{ marginTop: '10px' }}>{errorMessage}</Text>} {/* Display error message here */}
        </Form.Item>
      </Form>
      <Text type="secondary" style={{ fontSize: "10px" }}>
        Verification sent to {data.phoneNumber}{" "}
        <Link onClick={() => data.changeStep("user")}>Edit Phone Number</Link>
      </Text>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button type="primary" onClick={() => data.changeStep("user")}>
          Go Back
        </Button>
        <Button
          disabled={!Verified}
          type="primary"
          onClick={() => data.changeStep("plan")}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
export default PhoneValidationStep;
